import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@material-ui/core";
import { useStyles } from "./SubGroupPanel/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const SubGroupPanel = ({
  title,
  children,
  selectStep,
  accordionProps,
  infoString,
  conditions,
}) => {
  const classes = useStyles();

  return (
    <Accordion {...accordionProps}>
      <AccordionSummary
        expandIcon={accordionProps?.hasExpandIcon ? <ExpandMoreIcon /> : null}
        className={classes.summary}
      >
        <div className={classes.titleContainer}>
          <Typography className={classes.title} variant="body1">
            {title}
          </Typography>
          {conditions}
          {selectStep && infoString && (
            <Typography
              className={classes.detailInfo}
              variant="body2"
              color="textSecondary"
            >
              {infoString}
            </Typography>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default SubGroupPanel;
